import { render, staticRenderFns } from "./TypeOriginDialog.vue?vue&type=template&id=136c6666&"
import script from "./TypeOriginDialog.vue?vue&type=script&lang=js&"
export * from "./TypeOriginDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports